import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import styled from '@emotion/styled';
import { ArrowBack } from '@mui/icons-material';

import { InternalLink, StyledBackArrowRouterLink } from '../Link/Link';

interface Ipath {
  name: string;
  link: string;
}

interface IBreadCrumbs {
  pathData: Ipath[];
  backPagePath: string;
  pathId?: string;
}

const BreadCrumbs: React.FC<IBreadCrumbs> = ({
  pathData,
  backPagePath,
  pathId,
}) => {
  const { pathname } = useLocation();
  const { airbillId, airbillNumber } = useParams();

  return (
    <Container>
      <StyledBackArrowRouterLink to={`${backPagePath}`}>
        <ArrowBack style={{ color: '#F46F3B' }} />
      </StyledBackArrowRouterLink>
      {pathData.map((item, index) => {
        return (
          <React.Fragment key={index}>
            {`${item.link}/${airbillNumber}/${airbillId}` === pathname ? (
              <LinkShell
                className={
                  `${item.link}/${airbillNumber}/${airbillId}` === pathname
                    ? 'active'
                    : ''
                }
              >
                {item.name}
              </LinkShell>
            ) : (
              <InternalLink to={`${item.link}/${pathId}`}>
                <LinkShell
                  className={
                    `${item.link}/${airbillNumber}/${airbillId}` === pathname
                      ? 'active'
                      : ''
                  }
                >
                  {item.name}
                </LinkShell>
              </InternalLink>
            )}
          </React.Fragment>
        );
      })}
    </Container>
  );
};

export default BreadCrumbs;

const Container = styled.div`
  display: flex;
  /* justify-content: center; */
  align-items: center;
  gap: 0.5rem;
  /* border: 2px solid red; */
`;

const LinkShell = styled.div`
  display: flex;
  background-color: white;
  border-radius: 0.5rem;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.tertiaryText};
  font-size: 0.875rem;
  font-weight: 400;
  background: ${({ theme }) => theme.palette.borderLineColor};
  border: 1px solid ${({ theme }) => theme.palette.borderLineColor};
  padding: 0.8rem;

  &.active {
    color: #504b49;
    border: 1px solid ${({ theme }) => theme.palette.borderLineColor};
    font-weight: 600;
    background: white;
    font-weight: 700;
    padding-left: 0.65rem;
    padding-right: 0.65rem;
    cursor: default;
  }
`;
